module.exports = __webpack_public_path__ + "static/SONO-25051-cf917a9eb422ca3edcb8be2fb76dd54f.jpg";